import React from 'react'
import About from './pages/About/About'
import './App.css'

const App = () => {
  return (
	<div><About/></div>
  )
}

export default App